import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsCompanySchema = withDefaults({
  type: 'pcs-company',
  fields: [
    {
      kind: 'attribute',
      name: 'providerId',
    },
    {
      kind: 'attribute',
      name: 'providerData',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsProvider',
      type: 'pcs-provider',
      options: {
        async: false,
        inverse: 'pcsCompanies',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsCards',
      type: 'pcs-card',
      options: {
        async: false,
        inverse: 'pcsCompany',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsMerchants',
      type: 'pcs-merchant',
      options: {
        async: false,
        inverse: 'pcsCompany',
      },
    },
  ],
});

export default PcsCompanySchema;
